import { ReactElement, useCallback, useMemo } from "react";
import { LliLinkButton } from "@idwal/idwal-react-components";
import { ScreeningPscInspection } from "../../types/Screening";
import { LoadingParticulars } from "../loading/LoadingParticulars";
import { useTranslation } from "react-i18next";
import { sendGAEvent } from "../../services/AnalyticsService";
import {
    GA_BUTTON_EVENT,
    GA_CLICK_LLI_LINK
} from "../../constants/GaEvents";
import { ScreeningPSCAggregates } from "./ScreeningPscAggregates";
import { ScreeningPSCInspectionTable } from "./ScreeningPscInspectionTable";

type Props = {
    pscInspections: ScreeningPscInspection[];
    pscLoading: boolean;
    pscError: boolean;
};

export const ScreeningPscPerformance = (props: Props): ReactElement => {
    const { pscInspections, pscLoading, pscError } = props;

    const { t } = useTranslation("locale");

    const vesselId = useMemo(
        () => (pscInspections.length ? `${pscInspections[0].vessel_id}` : ""),
        [pscInspections]
    );

    const gaEvent = useCallback(() => {
        sendGAEvent(GA_BUTTON_EVENT, GA_CLICK_LLI_LINK);
    }, []);
    
    const pageHeader = (
        <div className="flex justify-content-between">
            <p className="psc-header">
                {t("psc.psc_performance_36")}
            </p>
            {vesselId ? (
                <LliLinkButton vesselId={vesselId} gaEvent={gaEvent} route="inspections" />
            ) : (
                <LliLinkButton />
            )}
        </div>
    );

    const noIncidentsMessage = (
        <div className="flex justify-content-center align-items-center h-3rem" style={{ backgroundColor: "#FCFCFC" }}>
            {t("psc.noPscData")}
        </div>
    );

    const errorMessage = (
        <div className="flex justify-content-center align-items-center h-3rem" style={{ backgroundColor: "#FCFCFC" }}>
            {t("psc.unavailable")}
        </div>
    );

    if (pscLoading) {
        return <LoadingParticulars />;
    }

    const messageContent = pscError ? errorMessage : noIncidentsMessage;

    return (
        <div className="flex flex-column psc-performance">
            {pageHeader}
            {pscInspections.length > 0 ? (
                <>
                    <ScreeningPSCAggregates pscInspections={pscInspections} />
                    <ScreeningPSCInspectionTable pscInspections={pscInspections} />
                </>
            ) : (
                messageContent
            )}
        </div>
    );
};
